<template>
  <div>
    <div>
      <div class="wrapper-x-40">
        <AdminTypesForm :type="type" />
      </div>
    </div>
  </div>
</template>

<script>
import AdminTypesForm from "../../../components/Admin/Types/Form";

export default {
  name: "TypesForm",
  components: { AdminTypesForm },
  computed: {
    slug() {
      return this.$route.params.slug;
    },
    element_group() {
      return this.$store.state.elements.element_group;
    },
    licensed() {
      return this.$store.getters["licensed"];
    },
    type() {
      const typeFromShow = this.$store.state.types.type;
      if (typeFromShow && typeFromShow.data) return typeFromShow;
      return this.$store.state.types.edit;
    },
  },
};
</script>
